import NPCType from "../enums/NPCType";

const NPCS = {
  [NPCType.FAIRY]: {
    charName: "Fairy",
    surname: "Savior!",
    spriteName: "fairy_npc.png",
    description: "A fairy who redeems sins",
    showcase: [],
  },
  [NPCType.VAMPRIE]: {
    charName: "Demon",
    surname: "!Savior",
    spriteName: "vamprie_npc.png",
    description: "A person who is completely evil is a demon",
    showcase: [],
  },
  [NPCType.BUSINESSMAN]: {
    charName: "Merchant",
    surname: "Capitalist",
    spriteName: "genie_npc.png",
    description: "A completely evil demon is a capitalist",
    showcase: [],
  },
};

export default NPCS;
